/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAmplitudeIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-amplitude" */ './utils').then((m) => m.AmplitudeIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/amplitude/icon' },
);

const LazyAmplitudeSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-amplitude-search-result" */ './utils').then(
			(m) => m.AmplitudeSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/amplitude/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AmplitudeIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAmplitudeIconComponent />
	</Suspense>
);

export const AmplitudeSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAmplitudeSearchResultIconComponent />
	</Suspense>
);
